import { useCallback, useEffect } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import getLang from 'LearningCenterUI/utils/getLang';
import UsageTracker from '../../utils/UsageTracker';
import { cleanTrackingProps } from '../../utils/awardTrackingUtils';
import { useHistory, useRouteMatch, useLocation } from 'quartz-routing/react-router';
import { getAwardSharingPath } from '../../utils/RoutingUtils';
import { SingleAchievement, useAchievementByTrackId, useTrackPublicData } from '../../features/achievement';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AchievementPreviewModal = () => {
  var _trackPublicData$name;
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();
  const {
    trackId: trackIdParam
  } = match.params;
  const trackId = Number(trackIdParam);
  const {
    achievement
  } = useAchievementByTrackId(trackId);
  const {
    track: trackPublicData
  } = useTrackPublicData(trackId);
  const trackName = (_trackPublicData$name = trackPublicData === null || trackPublicData === void 0 ? void 0 : trackPublicData.name) !== null && _trackPublicData$name !== void 0 ? _trackPublicData$name : '';
  useEffect(() => {
    if (!trackName) return;
    UsageTracker.trackStandalone('Award Interaction', cleanTrackingProps({
      action: 'view-achievement-preview-modal',
      type: 'certification',
      name: trackName,
      trackId: trackId.toString(),
      trackName,
      view: 'achievement-preview-modal'
    }));
  }, [trackId, trackName]);
  const handleClose = useCallback(() => {
    UsageTracker.trackStandalone('Award Interaction', cleanTrackingProps({
      action: 'close-achievement-preview-modal',
      type: 'certification',
      name: trackName,
      trackId: trackId.toString(),
      trackName,
      view: 'achievement-preview-modal'
    }));
    // Preserve the location state when navigating back to award sharing
    history.push(getAwardSharingPath(trackId), location.state);
  }, [trackId, trackName, history, location]);
  if (!achievement) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "achievement-preview-modal",
    use: "conversational",
    width: 1250,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      color: "icon-core-subtle",
      "data-test-id": "achievement-close-preview",
      marginBlockStart: "50",
      onClick: handleClose
    }), /*#__PURE__*/_jsx(SingleAchievement, {
      inModal: true,
      language: getLang(),
      publicId: achievement.publicId,
      trackEvent: emptyFunction
    })]
  });
};
export default AchievementPreviewModal;